import React from 'react';
import { StyleSheet, View } from './base_components';

const styles = StyleSheet.create({
  modalContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
});

let g_globalDialog: ModalContent;
let g_overlayIndex = 1;

type Props = {};
type State = {
  overlay_list: any[];
};
export default class ModalContent extends React.PureComponent<Props, State> {
  constructor(props, context) {
    super(props, context);
    g_globalDialog = this;

    this.state = {
      overlay_list: [],
    };
  }
  componentDidMount() {
    g_globalDialog = this;
  }

  static showAlert(text: string, delay: number = 0) {
    if (delay > 0) {
      setTimeout(() => {
        ModalContent.showAlert(text, 0);
      }, delay);
    } else {
      window.alert(text);
    }
  }
  static showOverlay(overlay: any) {
    if (g_globalDialog) {
      const overlay_list = g_globalDialog.state.overlay_list.slice();
      overlay.key = g_overlayIndex++;
      overlay_list.push(overlay);
      g_globalDialog.setState({ overlay_list });
    }
  }
  static hideOverlay() {
    if (g_globalDialog) {
      const overlay_list = g_globalDialog.state.overlay_list.slice();
      overlay_list.pop();
      g_globalDialog.setState({ overlay_list });
    }
  }
  static reset() {
    if (g_globalDialog) {
      g_globalDialog.setState({ overlay_list: [] });
    }
  }

  render() {
    const { overlay_list } = this.state;
    let content = null;
    if (overlay_list && overlay_list.length > 0) {
      content = (
        <View style={styles.modalContent} pointerEvents='box-none'>
          {overlay_list}
        </View>
      );
    }
    return content;
  }
}
